import { Link } from "react-router-dom";
import { Compass, Instagram, Twitter, Youtube } from "lucide-react";
import { CATEGORIES, SITE } from "@/lib/site";
import { Newsletter } from "@/components/Newsletter";

export const Footer = () => (
  <footer className="bg-brand-forest text-white mt-20" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-full bg-brand-terra text-white flex items-center justify-center">
              <Compass size={20} />
            </span>
            <span className="font-heading text-2xl font-semibold">{SITE.name}</span>
          </div>
          <p className="text-white/70 max-w-md leading-relaxed mb-6">{SITE.description}</p>
          <p className="text-xs uppercase tracking-[0.2em] text-brand-terra mb-3">Recibe los mejores chollos</p>
          <Newsletter variant="footer" />
          <div className="flex gap-4 mt-6">
            <a href="#" aria-label="Instagram" className="text-white/70 hover:text-brand-terra transition-colors"><Instagram size={20} /></a>
            <a href="#" aria-label="Twitter" className="text-white/70 hover:text-brand-terra transition-colors"><Twitter size={20} /></a>
            <a href="#" aria-label="YouTube" className="text-white/70 hover:text-brand-terra transition-colors"><Youtube size={20} /></a>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-xl font-semibold mb-4">Categorías</h4>
          <ul className="space-y-2">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/categoria/${c.slug}`} className="text-white/70 hover:text-white transition-colors text-sm">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-xl font-semibold mb-4">Información</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/sobre-nosotros" className="text-white/70 hover:text-white transition-colors">Sobre nosotros</Link></li>
            <li><Link to="/contacto" className="text-white/70 hover:text-white transition-colors">Contacto</Link></li>
            <li><Link to="/politica-de-privacidad" className="text-white/70 hover:text-white transition-colors">Política de privacidad</Link></li>
            <li><Link to="/politica-de-cookies" className="text-white/70 hover:text-white transition-colors">Política de cookies</Link></li>
            <li><Link to="/aviso-legal" className="text-white/70 hover:text-white transition-colors">Aviso legal</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/15 mt-12 pt-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/50">
        <p>© {new Date().getFullYear()} {SITE.name} · {SITE.domain}</p>
        <p>Hecho para viajeros que quieren ver el mundo gastando menos.</p>
      </div>
    </div>
  </footer>
);
